import { render, staticRenderFns } from "./Paying.vue?vue&type=template&id=855c2b16"
import script from "./Paying.vue?vue&type=script&lang=js"
export * from "./Paying.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports